import { render, staticRenderFns } from "./TrafficRequestHistoryTable.vue?vue&type=template&id=9f742710&scoped=true"
import script from "./TrafficRequestHistoryTable.vue?vue&type=script&lang=ts"
export * from "./TrafficRequestHistoryTable.vue?vue&type=script&lang=ts"
import style0 from "./TrafficRequestHistoryTable.vue?vue&type=style&index=0&id=9f742710&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f742710",
  null
  
)

export default component.exports